import { discardAnalytics } from '@/lib/analytics';
import { consentState, onConsentChange, watchConsent, } from '@/lib/consent/consentState';
import { syncSentryReplay } from '@/lib/sentry';
/**
 * Apply the visitor's consent to the optional features, now and on every change. Called once at
 * startup, after initSentry(). Product analytics checks consent per event on its own
 * (lib/analytics); this only has to drop what it already holds when consent goes away.
 */
export function initConsent() {
    applyConsent(consentState());
    onConsentChange(applyConsent);
    watchConsent();
}
function applyConsent(state) {
    syncSentryReplay(state.performance);
    if (!state.analytics)
        discardAnalytics();
}
